import {Utils} from 'components/shared';

const keyModifier = Utils.getKeyModifier();

var keymap = {};

export default keymap;
